import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';


@Component({
    selector: 'bulk-delete-confirmation',
    templateUrl: './bulk-delete-confirmation.component.html',
    styleUrls: ['./bulk-delete-confirmation.component.scss'],
    standalone: false
})
export class BulkDeleteConfirmationComponent implements OnInit {
  companyItems = 0;
  subCompanyItems = 0;
  inputText = null;
  expectedText = '0';

  itemName: BulkDeleteConfirmationData['itemName'];
  selectedItems: BulkDeleteConfirmationData['selectedItems'];

  constructor(
    public dialogRef: MatDialogRef<BulkDeleteConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: BulkDeleteConfirmationData,
    private companyStateService: CompanyStateService) {
      this.selectedItems = data.selectedItems;
      this.itemName = data.itemName;
    }

  ngOnInit(): void {
    this.selectedItems.forEach((item) => {
      if (item.companyId === this.companyStateService.getSelectedCompanyId()) {
        this.companyItems++;
      } else {
        this.subCompanyItems++;
      }
    });

    this.expectedText = this.selectedItems.length.toString();
  }

  delete() {
    if (this.inputText === this.expectedText) {
      this.dialogRef.close(true);
    }
  }

  dismiss() {
    this.dialogRef.close(false);
  }

}

export interface BulkDeleteConfirmationData {
  selectedItems: {companyId: string}[];
  itemName: 'Display' | 'Presentation' | 'Schedule';
}
